import { Component, Input, ViewContainerRef, Inject } from '@angular/core';
import { ChatMessage } from '../digital-assistant.model';
import { ComponentMappingService } from './chat/services/component-mapping.service';
import { BaseMessageComponent } from './base-message.component';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

@Component({
  selector: 'miq-dynamic-chat-loader',
  template: ` <ng-container #container></ng-container> `,
  styles: [],
  standalone: false,
})
export class DynamicLoaderComponent {
  constructor(
    private viewContainerRef: ViewContainerRef,
    private mappingService: ComponentMappingService,
    @Inject(CbreLoggerToken) private readonly logger: CbreLogger
  ) {}

  @Input() set message(message: ChatMessage) {
    if (!message || !message.type) {
      this.logger.error('Invalid message or message type');
      return;
    }
    const ComponentClass = this.mappingService.getComponent(message.type ?? 'text');
    if (ComponentClass) {
      this.viewContainerRef.clear();
      const componentRef = this.viewContainerRef.createComponent(ComponentClass);
      (componentRef.instance as BaseMessageComponent).content = message.content;
    }
  }
}
